module.exports = __webpack_public_path__ + "static/media/scale.d87b3b21.svg";